import React from 'react';
import CustomColorPicker from '../../../components/Elements/ColorPicker/index';
import { ColorPickerWrapper } from '../edit-form-version.styled';

export const ColorPicker = ({
  selectedColor,
  label,
  className,
  settingKey,
  onChangeColor,
  colorPicker = '',
  topLabel,
  setColorPicker = () => {},
}) => {
  return (
    <ColorPickerWrapper className={className} selectedColor={selectedColor}>
      {topLabel ? (
        <div className="flex-column flex-1">
          <label className="regular-text mb-1 regular-text lighter-text">{topLabel}</label>
          <div className="flex items-center pxy-1 divider-border radius-4 relative picker-container">
            <div
              className="color divider-border cursor mr-2"
              onClick={() => setColorPicker(colorPicker === settingKey ? '' : settingKey)}
            />
            <label className="regular-text font-16 flex-1">{selectedColor}</label>
            {colorPicker === settingKey && (
              <CustomColorPicker
                onChangeComplete={color => onChangeColor(settingKey, color.hex)}
                close={() => setColorPicker('')}
                color={selectedColor || '#000000'}
                setColor={color => onChangeColor(settingKey, color)}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center flex-1">
          {label && <label className="regular-text flex-1">{label}</label>}
          <div className="flex flex-1 items-center pxy-1 divider-border radius-4 relative picker-container">
            <div
              className="color divider-border cursor mr-2"
              onClick={() => setColorPicker(colorPicker === settingKey ? '' : settingKey)}
            />
            <label className="regular-text font-16 flex-1">{selectedColor}</label>
            {colorPicker === settingKey && (
              <CustomColorPicker
                onChangeComplete={color => onChangeColor(settingKey, color.hex)}
                close={() => setColorPicker('')}
                color={selectedColor || '#000000'}
                setColor={color => onChangeColor(settingKey, color)}
              />
            )}
          </div>
        </div>
      )}
    </ColorPickerWrapper>
  );
};
